module.exports = __webpack_public_path__ + "static/img/riding-apeach.a372190.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/riding-apeach.png
// module id = jSZ1
// module chunks = 1